import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import '@/config/ui2024'
import { category, majorID,majorTag } from '@base/settings'
import filter from './utils/filter'
import '@/utils/moveAndDrag'

Vue.prototype.$categoryInfo = { category: category, majorID: majorID,majorTag:majorTag}
//全局导入过滤器
Object.keys(filter).forEach(key => Vue.filter(key, filter[key]))

Vue.config.productionTip = false

//计算器
window.math.config({ number: "BigNumber" });
Vue.prototype.$math = window.math;
window['_calc_element'] = 'test'

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
